import { Provincia } from './provincia';
export class Localidad {
	id: number;
	descripcion: string;
	codigoINDEC: string;
	provincia: Provincia;
	departamento: number;
	lat: number;
	lon: number;
	fuente: string;
	activo: boolean;
	parada: boolean;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.descripcion = data.descripcion;
			this.codigoINDEC = data.codigoINDEC;
			this.provincia = data.provincia;
			this.departamento = data.departamento;
			this.lat = data.lat;
			this.lon = data.lon;
			this.fuente = data.fuente;
			this.activo = data.activo;
			this.parada = data.parada;
		}
	}
}
